import { getAccessToken, getRefreshToken, setTenantId, setToken } from "@/utils/auth";
import * as LoginApi from "@/api/login";
import { ref } from "vue";

const currentTenantId = ref("");

// SSO 自动登录检查
export function checkAndAutoSSOLogin(TenantId) {
  console.log("TenantId", TenantId);
  // 空值直接返回
  if (!TenantId) {
    return;
  }
  // 已登录直接返回
  const token = getAccessToken();
  if (token) {
    return;
  }
  currentTenantId.value = TenantId;
  autoSSOLogin();
}

// 自动登录执行
async function autoSSOLogin() {
  try {
    const res = await LoginApi.ssoLogin(currentTenantId.value);
    // 获取 token
    let token = res?.accessToken || res?.refreshToken;
    if (!token) {
      console.error("登录失败：未获取到有效 token", res);
      return;
    }
    console.log("res", res);
    // 保存 token
    setToken(res);
    setTenantId(currentTenantId.value);
    console.log("登录成功-getAccessToken()", getAccessToken());
  } catch (err) {
    console.error("SSO 自动登录异常：", err);
  }
}
